import React from 'react';
import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'; 
import ContactUs from './Componenets/ContactUs/ContactUs';  
import AdminLogin from './Componenets/Admin/AdminLogin';
import LeadPage from './Componenets/Admin/Leadpage';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<AdminLogin />} />
          <Route path="/ContactUs" element={<ContactUs />} />
          <Route path="/Leadpage" element={<LeadPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
